module.exports = __webpack_public_path__ + "img/2.08d40910.png";